export default {
    supportEmail: 'support@cyberfusion.io',
    supportPhoneNumber: '+31 (0)40 711 44 96',
    website: 'https://www.cyberfusion.io',
};
